import React, {Component} from "react";
import Axios from "axios";
import getAxiosConfig from "../../utils/axiosConfig";
import User from "./User";
import urlList from "../../reducers/propertiesReducer";
import Popup from "reactjs-popup";
import {checkIfFieldValid, REGEX} from "../../utils/common";
import messageCodes from "../../utils/messageCodes";
import {showToastForBackend, showToastForFrontend} from '../../actions/toastActions'
import {FormattedMessage} from 'react-intl';
import {
    createTheme,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    ThemeProvider
} from "@mui/material";
import {connect} from "react-redux";

class UserManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            open: false,
            newUserName: '',
            newUserEmail: '',
            newUserPassword: '',
            newUserIsAdmin: false,
            newUserIsActive: true,
            newPasswordExpireAfter: 90,
            selectedPrivileges: {},
            isNewEmail: true,
            checkNewUserValidation: false
        };
        this.getUsers = this.getUsers.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.createUser = this.createUser.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.checkIfEmailExists = this.checkIfEmailExists.bind(this);
        this.handleSelection = this.handleSelection.bind(this);

    }

    async componentDidMount() {
        await this.getUsers();
    }


    async checkIfEmailExists(email){
        if (email){
            await Axios.get(`${urlList().userManagementUrl}/${email}`, getAxiosConfig())
                .then(response => {
                    if (response.status === 200) {
                        this.setState({
                            isNewEmail: response.data
                        });
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                    }
                });
        }
    }


    createUser(event) {
        event.preventDefault();
        const {selectedPrivileges} = this.state;
        this.props.navigation.mainNavigation.forEach((element) => {
            if (!Object.keys(selectedPrivileges).includes(element.title)) {
                selectedPrivileges[element.title] = "read-only";
            }
        });
        this.checkIfEmailExists(this.state.newUserEmail).then(() => {
            if (
                !this.state.newUserName ||
                checkIfFieldValid(this.state.newUserEmail, REGEX.EMAIL) ||
                !this.state.isNewEmail ||
                !this.state.newUserPassword
            ) {
                this.setState({checkNewUserValidation: true});
                return;
            }

            Axios.post(
                `${urlList().userManagementUrl}`,
                {
                    name: this.state.newUserName,
                    email: this.state.newUserEmail,
                    isAdmin: this.state.newUserIsAdmin,
                    isActive: this.state.newUserIsActive ? 1 : 0,
                    privileges: JSON.stringify(selectedPrivileges),
                    password: this.state.newUserPassword,
                    passwordExpireAfter: this.state.newPasswordExpireAfter
                },
                getAxiosConfig()
            ).then(() => {
                this.getUsers();
                this.setState({
                    open: false,
                    newUserName: '',
                    newUserEmail: '',
                    newUserPassword: '',
                    newUserIsAdmin: false,
                    newUserIsActive: false,
                    newPasswordExpireAfter: 90,
                    isNewEmail: true,
                    checkNewUserValidation: false
                });
            }).catch(err => {
                if (err.response){
                    this.props.showToastForBackend(err.response.data);
                }
                else{
                    this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }

            });
        });

    }

    handleSelection(element, value) {
        this.setState((prevState) => ({
            selectedPrivileges: {
                ...prevState.selectedPrivileges,
                [element]: value,
            },
        }));
    }



    handleChange({target}) {
        if (target.type === "checkbox") {
            this.setState({[target.name]: target.checked});
        } else {
            this.setState({[target.name]: target.value});
        }
        if (target.name === 'newUserIsAdmin' && target.checked) {
            let adminPrivileges = {};
            this.props.navigation.mainNavigation.forEach((element) => {
                adminPrivileges[element.title] = "write";
            });
            this.setState({
                selectedPrivileges: adminPrivileges
            });
        }
    }



    openModal() {
        this.setState({open: true, checkNewUserValidation: false});
    }

    closeModal() {
        this.setState({open: false, checkNewUserValidation: false});
    }

    async getUsers() {
        await Axios.get(`${urlList().userManagementUrl}`, getAxiosConfig())
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        users: response.data
                    });
                }
            })
            .catch(error => {
                if (!error.response) {
                    this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            });
    }

    setEmailClassName(email){
        if (this.state.isNewEmail){
            return checkIfFieldValid(email, REGEX.EMAIL);
        } else {
            return 'user-input-invalid';
        }
    }

    render() {

        const contentStyle = {
            width: "60%"
        };
        const theme = createTheme({
            palette: {
                primary: {
                    main: '#86BC25FF',
                },
            },
        });

        return (
            <div className="user-management">
                <div className="record">
                    <div className="create-user-area">
                        <button className="create-user-btn" onClick={this.openModal}>
                            <FormattedMessage id="Create New User!"/>
                        </button>
                        <Popup
                            open={this.state.open}
                            modal
                            contentStyle={contentStyle}
                            closeOnDocumentClick
                            onClose={this.closeModal}
                        >
                            <div>
                                <div className="header">
                                    <FormattedMessage id="Create New User"/>
                                </div>
                                <div className="content">
                                    <form className="form" onSubmit={this.createUser}>
                                        <div className="form-row">
                                            <div className="form-label"><FormattedMessage id="Name"/></div>
                                            <input
                                                name="newUserName"
                                                value={this.state.newUserName}
                                                onChange={this.handleChange}
                                                className={this.state.checkNewUserValidation ? 'user-input-invalid' : 'user-input'}/>
                                        </div>

                                        <div className="form-row">
                                            <div className="form-label"><FormattedMessage id="Email"/></div>
                                            <input
                                                name="newUserEmail"
                                                value={this.state.newUserEmail}
                                                onChange={this.handleChange}
                                                className={(this.state.checkNewUserValidation) ? this.setEmailClassName(this.state.newUserEmail) : 'user-input'}/>
                                        </div>

                                        {(this.state.newUserEmail && this.state.checkNewUserValidation) ?
                                            <div className="form-row">
                                                        <span
                                                            className={
                                                                (this.state.newUserEmail && this.state.checkNewUserValidation) ?
                                                                    this.setEmailClassName(this.state.newUserEmail) + ' custom-email-error' : 'custom-email-error'}>
                                                            Email already exists.</span>
                                            </div>
                                            : ""}

                                        <div className="form-row">
                                            <div className="form-label"><FormattedMessage id="Password"/></div>
                                            <input
                                                name="newUserPassword"
                                                value={this.state.newUserPassword}
                                                onChange={this.handleChange}
                                                className={this.state.checkNewUserValidation ? 'user-input-invalid' : 'user-input'}/>
                                        </div>

                                        <div className="form-row">
                                            <div className="form-label"><FormattedMessage id="Password expire after(days)"/></div>
                                            <input
                                                className="user-input"
                                                name="newPasswordExpireAfter"
                                                value={this.state.newPasswordExpireAfter}
                                                onChange={this.handleChange}
                                            />
                                        </div>

                                        <div className="form-row">
                                            <div className="form-label"><FormattedMessage id="Admin"/></div>
                                            <div className="checkbox-container">
                                                <input
                                                    className="checkbox"
                                                    name="newUserIsAdmin"
                                                    type="checkbox"
                                                    defaultChecked={this.state.newUserIsAdmin}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-row">
                                            <div className="form-label"><FormattedMessage id="Active"/></div>
                                            <div className="checkbox-container">
                                                <input
                                                    className="checkbox"
                                                    name="newUserIsActive"
                                                    type="checkbox"
                                                    defaultChecked={this.state.newUserIsActive}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                        </div>

                                        {!this.state.newUserIsAdmin && (
                                            <div className="form-row">
                                                <div className="form-label"><FormattedMessage id="Privileges"/></div>
                                                <div className="privilege-container">
                                                    {this.props.navigation.mainNavigation.map((element, index) => (
                                                        <div className="privilege-selection" key={index}>
                                                            <ThemeProvider theme={theme}>
                                                                <div style={{width: '100%'}}>
                                                                    <FormControl component="fieldset"
                                                                                 sx={{flexDirection: 'row', alignItems: 'center', width: '100%'}}>
                                                                        <div className="radio-label">
                                                                            <FormLabel  component="legend">{element.title}</FormLabel>
                                                                        </div>
                                                                        <div className="radio-group">
                                                                            <RadioGroup
                                                                                sx={{flexDirection: 'row'}}
                                                                                aria-label={element.title}
                                                                                name={element.title}
                                                                                value={this.state.selectedPrivileges[element.title] || "read-only"}
                                                                                onChange={(event) => this.handleSelection(element.title, event.target.value)}
                                                                            >
                                                                                <FormControlLabel value="no access"
                                                                                                  control={<Radio/>}
                                                                                                  label="no access"
                                                                                                  sx={{visibility: element.title === 'Analytics' ? 'hidden' : 'visible'}}/>
                                                                                <FormControlLabel value="read-only"
                                                                                                  control={<Radio/>}
                                                                                                  label="read-only"/>
                                                                                <FormControlLabel value="write"
                                                                                                  control={<Radio/>}
                                                                                                  label="write"/>
                                                                            </RadioGroup>
                                                                        </div>
                                                                    </FormControl>
                                                                </div>
                                                            </ThemeProvider>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        <div className="button-container">
                                            <button
                                                className="save-btn"
                                                onClick={this.createUser}>
                                                Save
                                            </button>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Popup>
                    </div>


                    <Table sx={{marginTop: '30px', height: '80%'}}>
                        <TableHead>
                            <TableRow>
                                <TableCell className="header"><FormattedMessage id="id"/></TableCell>
                                <TableCell className="header"><FormattedMessage id="User Name"/></TableCell>
                                <TableCell className="header"><FormattedMessage id="Email"/></TableCell>
                                <TableCell className="header"><FormattedMessage id="Admin"/></TableCell>
                                <TableCell className="header"><FormattedMessage id="Active"/></TableCell>
                                <TableCell className="header"><FormattedMessage id="Modify"/></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.users.map(user => (
                                <User
                                    key={user.id}
                                    id={user.id}
                                    name={user.name}
                                    email={user.email}
                                    isAdmin={user.isAdmin}
                                    isActive={user.isActive}
                                    password={user.password}
                                    passwordExpireAfter={user.passwordExpireAfter}
                                    privileges={user.privileges}
                                    updateUsers={this.getUsers}
                                />

                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
        navigation: state.navigation
    };
}

export default connect(mapStateToProps, {showToastForFrontend, showToastForBackend})(UserManagement);
